import { FoodsIcon } from "@foodpilot/foods";
import { Box, Button, CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePropertyContext } from "../context/usePropertyContext";
import { ErrorMessages } from "./ErrorMessages";
import { DragAndDrop } from "./DragAndDrop";
import { UploadedFile } from "./UploadedFile";
import { TemporaryFile } from "./TemporaryFile";
import { MAX_FILE_SIZE_MB } from "../context/hooks/attachmentLimits";

export const FileUploadAttachmentDialogContent = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    const { attachmentState, post } = usePropertyContext();
    const canAnswerSsq = post.canAnswerSsq;

    return (
        <Stack
            alignItems="center"
            padding={{ xs: theme.spacing(2), md: theme.spacing(4) }}
            gap={theme.spacing(2)}
            sx={{ backgroundColor: theme.palette.grey[200] }}
        >
            {canAnswerSsq && <DragAndDrop />}
            <UploadedFile />
            {canAnswerSsq && <TemporaryFile />}
            {/* <WhiteBox
                sx={{
                    width: "100%",
                    border: `dashed ${theme.palette.grey[500]}`
                }}
                display={{ xs: "none", md: "block" }}
                borderRadius={theme.spacing(1)}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                {!attachmentState.isUploading && (
                    <Stack alignItems="center" padding={theme.spacing(4, 4)} gap={theme.spacing(1)}>
                        <Box display="flex" alignItems="center" sx={{ color: theme.palette.grey[900] }}>
                            <FoodsIcon icon="uploadFile" size={8} />
                        </Box>
                        <Box display="flex" alignItems="center">
                            <Typography variant="body2" sx={{ lineHeight: "normal" }}>
                                {t("property.drop_file_from_computer", "Drop your file here or")}
                            </Typography>
                            <Button
                                variant="text"
                                sx={{
                                    cursor: "pointer",
                                    marginLeft: theme.spacing(0.5),
                                    lineHeight: "normal",
                                }}
                                onClick={triggerFileInput}
                            >
                                {t("property.upload_file_from_computer", "Upload file here")}
                            </Button>
                        </Box>
                        <Typography variant="body2" color="textSecondary">
                            {t("property.file_upload_info", "Supported formats : PDF, docx, pptx, xlsx, PNG, JPEG")}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {t("property.file_upload_size_info", "Maximum size : 2 MB")}
                        </Typography>
                        <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
                    </Stack>
                )}
                {attachmentState.isUploading && (
                    <Stack alignItems="center" padding={theme.spacing(6)}>
                        <CircularProgress size={50} color="primary" />
                        <Typography variant="h4">
                            {t("property.attachment.uploading", "Uploading your file…")}
                        </Typography>
                    </Stack>
                )}
            </WhiteBox> */}
            {/* <Stack
                display={{ xs: "flex", md: "none" }}
                width={"100%"}
                flexDirection={"column"}
                gap={theme.spacing(2)}
            >
                {!hasUploadedFile && (
                    <WhiteBox
                    sx={{
                        width: "100%",
                        border: `dashed ${theme.palette.grey[500]}`,
                        padding: theme.spacing(1.5),
                    }}
                    borderRadius={theme.spacing(1)}
                >
                    <Stack
                        flexDirection={"row"}
                        alignItems="center"
                        gap={theme.spacing(1)}
                    >
                        <Box display="flex">
                            <FoodsIcon icon="uploadFile" size={4} />
                        </Box>
                        <Typography
                            variant={"body-bold"}
                        >
                            {t("property.file_upload_info.no_file", "No file added")}
                        </Typography>
                    </Stack>
                    </WhiteBox>
                )}
                {hasUploadedFile && (
                    <WhiteBox
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            overflowWrap: "anywhere",
                        }}
                        padding={theme.spacing(2)}
                        alignItems="center"
                        borderRadius={theme.spacing(1)}
                    >
                        <Typography variant="body-medium">
                            {sanitizeFilename(attachmentState.selectedAttachment?.filename)}
                        </Typography>
                        <FoodsIconButton
                            size="s"
                            icon="delete"
                            buttonProps={{
                                onClick: () => setUploadedFile(null),
                            }}
                        />
                    </WhiteBox>
                )}

                {/* gap does not work for unknown reason */}
            {/* <Stack>
                        <Typography variant="body-semibold" color={theme.custom.grey[2000]}>
                            {t("property.file_upload_info", "Supported formats : PDF, docx, pptx, xlsx, PNG, JPEG")}
                        </Typography>
                        <Typography variant="body-semibold" color={theme.custom.grey[2000]}>
                            {t("property.file_upload_size_info", "Maximum size : 2 MB")}
                        </Typography>
                    </Stack> */}

            {/* </Stack> */}

            {canAnswerSsq && <ErrorMessages />}
            {/* {uploadedFile && !isUploading && (
                <WhiteBox
                    sx={{
                        width: "100%",
                        display: { xs: "none", md: "flex" },
                        justifyContent: "space-between"
                    }}
                    padding={theme.spacing(2)}
                    alignItems="center"
                    borderRadius={theme.spacing(1)}
                >
                    <Typography variant="body-medium" color="textSecondary">
                        {sanitizeFilename(uploadedFile.name)}
                    </Typography>
                    <FoodsIconButton
                        size="s"
                        icon="delete"
                        buttonProps={{
                            onClick: () => setUploadedFile(null),
                        }}
                    />
                </WhiteBox>
            )} */}
            {canAnswerSsq && (
                <Stack
                    width={"100%"}
                    display={{ xs: "none", md: "flex" }}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                >
                    <Button
                        variant="secondary"
                        startIcon={<FoodsIcon size={2} icon={"close"} />}
                        onClick={attachmentState.handleCancel}
                    >
                        {t("primarydialog.cancel")}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={attachmentState.saveSelectedFile}
                        disabled={!attachmentState.hasPendingFiles || attachmentState.isUploading}
                    >
                        {t("glossary.add")}
                    </Button>
                </Stack>
            )}
            {canAnswerSsq && (
                <Stack width={"100%"} gap={theme.spacing(2)} alignSelf={"start"} display={{ xs: "flex", md: "none" }}>
                    <Stack>
                        <Typography variant="body-semibold" color={theme.custom.grey[2000]}>
                            {t("property.file_upload_info", "Supported formats : PDF, docx, pptx, xlsx, PNG, JPEG")}
                        </Typography>
                        <Typography variant="body-semibold" color={theme.custom.grey[2000]}>
                            {t("property.file_upload_size_info", "Maximum size : {{maxSize}} MB", {
                                maxSize: MAX_FILE_SIZE_MB,
                            })}
                        </Typography>
                    </Stack>
                    <Box borderTop={`1px solid ${theme.custom.grey[600]}`} />
                    <Stack width={"85%"} gap={theme.spacing(1)}>
                        <Button
                            variant="secondary"
                            startIcon={<FoodsIcon size={2} icon={"addFile"} />}
                            // onClick={handleSaveClose}
                            onClick={attachmentState.triggerFileInput}
                            disabled={attachmentState.isUploading}
                            sx={{ justifyContent: "start" }}
                        >
                            {t("property.upload_files.choose_files", "Choose files")}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={attachmentState.saveSelectedFile}
                            disabled={!attachmentState.hasPendingFiles || attachmentState.isUploading}
                        >
                            {attachmentState.isUploading ?
                                <CircularProgress />
                            :   t("glossary.add")}
                        </Button>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
};
